allow-visible-on-all-workspaces:
  title: Visibilidad Entre Espacios
  description: Permitir que la ventana sea visible en todos los espacios de trabajo, solo macOS.
spotlight:
  errors:
    unknown: Error desconocido
    prefix: 'Algo salió mal: {message}'
    shortcutRegistrationFailed: 'Algo salió mal: no se pudo registrar el atajo de Spotlight.'
pages:
  modules:
    mcp-server:
      description: Conectar y gestionar servidor MCP y herramientas
      title: Servidor MCP
  system:
    sections:
      section:
        window-shortcuts:
          title: Atajos de Teclado
    window-shortcuts:
      description: Modificar los atajos de ventana.
      title: Atajos de Ventana
      empty: Sin configurar
      spotlight:
        title: Atajo de Spotlight
        description: Haz clic en el atajo y pulsa un nuevo atajo. Pulsa Esc para cancelar.
      actions:
        recording: Pulsa las teclas
        reset: Restablecer
      errors:
        load: No se pudo cargar el atajo
        conflict: El atajo ya está en uso.
        failed: No se pudo actualizar el atajo
        requiresModifier: 'Usa al menos una de estas teclas: Cmd, Ctrl, Alt o Super.'
      toggle-move:
        label: Alternar Mover
      toggle-resize:
        label: Alternar Redimensionar
      toggle-ignore-mouse-event:
        label: Alternar Ignorar Evento del Ratón
      press-keys: Presionar Teclas...
    desktop-control:
      title: Desktop Control
      description: Allow the agent to control mouse, keyboard, and clipboard on this computer.
      section:
        title: Agent desktop control
        description: >-
          When enabled, chat tools can inject mouse and keyboard input.
          By default every action still asks for OS confirmation.
      enabled:
        label: Enable desktop control
        description: Master switch. Keep off unless you want the agent to operate this PC.
      always-allow:
        label: Always allow (dangerous)
        description: >-
          Skip the OS confirmation dialog for every action.
          Only use this if you fully trust the model and your setup.
        toast: Always-allow is on. Desktop actions will not ask for confirmation.
      emergency-stop:
        title: Emergency stop is active
        description: >-
          Desktop injection is blocked. Clear emergency stop, then turn the master switch on again if needed.
          Shortcut: Ctrl/Cmd+Shift+F12.
        clear: Clear emergency stop
        cleared: Emergency stop cleared
      hints:
        emergency-shortcut: Emergency stop shortcut is Ctrl+Shift+F12 (Cmd+Shift+F12 on macOS).
      errors:
        load: Failed to load desktop control settings
        save: Failed to update desktop control settings
    developer:
      sections:
        section:
          use-window-mouse:
            title: Herramienta useWindowMouse
            description: Evalúa la posición del cursor de la ventana de Electron
devtools:
  title: Desarrollador
  pages:
    context-flow:
      title: Flujo de contexto
    lag-visualizer:
      title: Visualizador de retraso
    performance-visualizer:
      title: Visualizador de rendimiento
      description: Cambiar FPS/tareas largas/superposición de memoria
    markdown-stress:
      title: Estrés por Markdown
      description: Análisis y renderizado de Markdown bajo estrés con cargas de chat pesadas
    io-tracer:
      title: IO Tracer
    widgets-calling:
      title: Llamada de Widget
screen-capture:
  permissions-prompt:
    title: Captura de pantalla
    description: Para capturar las pantallas o ventanas, se requieren permisos de grabación de pantalla y audio del sistema.
    open-preferences: Abrir Preferencias del Sistema
    dismiss: Descartar
    instructions:
      step-1: Abre "Preferencias del sistema", selecciona "Privacidad y Seguridad" en la barra lateral.
      step-2: En la sección "Grabación de audio de pantalla y sistema" y "Solo grabación de audio del sistema", encienda los interruptores para AIRI.
      step-2-note: Si AIRI no aparece en la lista, añádelo manualmente haciendo clic en el botón "+" y seleccionando AIRI de la carpeta Aplicaciones.
